import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {apiInstance, fetchStoreStock} from "../../api/api";

function StoreInventory() {
    const navigate = useNavigate();
    const [stock, setStock] = useState([]);
    // const [filteredStock, setFilteredStock] = useState([]);
    const [search, setSearch] = useState('');
    const [storeName, setStoreName] = useState('');

    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const fetchCurrentStore = async () => {
        try {
            const res = await apiInstance.get("/current-store/");
            setStoreName(res.data.name);
        } catch (err) {
            setStoreName("Unknown Store");
        }
    };

    useEffect(() => {
        loadStock(1);
        fetchCurrentStore();
    }, []);

    const loadStock = async (page, searchValue = search) => {
        const data = await fetchStoreStock(page, searchValue);
        setStock(data.results);
        // setFilteredStock(data.results); // reset filter on new page

        const pages = Math.ceil(data.count / 20); //backend page_size
        setTotalPages(pages);
        setCurrentPage(page);
    };

    // search handler
    const handleSearch = (e) => {
        const value = e.target.value;
        setSearch(value);
        loadStock(1, value); // backend search

        // const filtered = stock.filter(item =>
        //     item.product_name.toLowerCase().includes(value)
        // );
        // setFilteredStock(filtered);
    };

    const renderPagination = () => {
        const maxPages = 5;
        let start = Math.max(1, currentPage - 2);
        let end = Math.min(totalPages, start + maxPages - 1);

        if (end - start < maxPages - 1) {
            start = Math.max(1, end - maxPages + 1);
        }

        const pages = [];
        for (let i = start; i <= end; i++) {
            pages.push(
                <button
                    key={i}
                    className={`btn ${currentPage === i ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => loadStock(i)}
                >{i}</button>
            );
        }

        return (
            <div className="d-flex justify-content-center align-items-center gap-2 mt-3">
                <button
                    className="btn btn-outline-secondary"
                    onClick={() => loadStock(currentPage - 1)}
                    disabled={currentPage === 1}
                >
                    &laquo;
                </button>
                {pages}
                <button
                    className="btn btn-outline-secondary"
                    disabled={currentPage === totalPages}
                    onClick={() => loadStock(currentPage + 1)}
                >
                    &raquo;
                </button>
            </div>
        );
    };

    const handleBack = () => {
        navigate(-1);
    }

    return (
        <div className="container">
            <div className="back-button-container">
                <Button variant="danger" onClick={handleBack}>Back</Button>
            </div>
            <h3 className="mb-3">{storeName} Inventory</h3>

            {/*search bar*/}
            <div className="mb-3">
                <input
                    type="text"
                    className="form-control"
                    placeholder="Search product..."
                    value={search}
                    onChange={handleSearch}
                />
            </div>

            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>Product</th>
                        <th>Stock</th>
                    </tr>
                </thead>
                <tbody>
                    {stock.map((item) => (
                        <tr key={item.product_id}>
                            <td>{item.product_name}</td>
                            <td className={item.stock < 0 ? "text-danger fw-bold" : ""}>
                                {item.stock}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {renderPagination()}
        </div>
    );
}

export default StoreInventory;